import { VaultDepositorStats } from './VaultDepositorStats';
import { SpotMarketConfig } from '@drift-labs/sdk';
import { UiVaults } from 'src/constants/vaults';
import { VaultDepositorPerformanceBreakdown } from './VaultDepositorPerformanceBreakdown';
import { NotionalGrowthStrategyAlert } from '../VaultGraphs';

export const UserPerformance = (props: {
	depositAssetConfig: SpotMarketConfig;
	vaultPubkey: string;
}) => {
	const uiVaultConfig = UiVaults.getVaultConfig(props.vaultPubkey);

	return (
		<div className="flex w-full flex-col gap-y-lg">
			{uiVaultConfig?.isNotionalGrowthStrategy && (
				<NotionalGrowthStrategyAlert />
			)}

			<div className="flex w-full flex-col">
				<VaultDepositorStats
					depositAssetConfig={props.depositAssetConfig}
					vaultPubkey={props.vaultPubkey}
				/>
			</div>
			<VaultDepositorPerformanceBreakdown
				depositAssetConfig={props.depositAssetConfig}
				vaultPubkey={props.vaultPubkey}
			/>
		</div>
	);
};
